
$( document ).ready(function() {  
  
  $(document ).on("click", ".bcpo-image-parent" , function(){
    var index = $(this).index();

    $(".bcpo-label .mark_qustion").remove();
    $(".bcpo-images .bcpo-label label").append('<img src="//cdn.shopify.com/s/files/1/2401/4131/files/145-1450575_question-mark-faqs-icon-facebook-image-in-png.png" class="mark_qustion">');


    if( index == 0 || index == 1 || index == 2 || index == 3 || index == 4 ) {

      $(".bcpo-label .mark_qustion").attr('title', 'These kits include an encoder for you to set your chosen 4-digit code in the cap. Kits of multiple bottles that allow you to set your own 4-digit codes.');

    } else {

      $(".bcpo-label .mark_qustion").attr('title', 'These bottles include a non-changeable 4-digit code set in the cap. Bottles with 4-digit codes that are provided for you and cannot be changed.');

    }
    $('.bcpo-label .mark_qustion').addClass('simpletooltip');

    $('.bcpo-label .mark_qustion').attr('data-simpletooltip-position', 'right');

    $('.bcpo-label .mark_qustion').simpletooltip({
      position: 'right',
      border_color: '#25418F',
      color: '#FFFFFF',
      background_color: '#25418F',
      border_width: 3
    });        
  });
  
   $(document ).on("click", "#bcpo-select-option-1 div" , function(){
    var index = $(this).index();

    $(".bcpo-label .mark_button").remove();
    $(".bcpo-buttons .bcpo-label label").append('<img src="//cdn.shopify.com/s/files/1/2401/4131/files/145-1450575_question-mark-faqs-icon-facebook-image-in-png.png" class="mark_button">');

    if( index == 0 ) {
      $(".bcpo-label .mark_button").attr('title', 'Small - 4.5"(H) X 1.5"(W)');
    } 
    if( index == 1 ) {
      $(".bcpo-label .mark_button").attr('title', 'Large - 5.4"(H) X 2"(W)');
    }
    if( index == 2 ) {
      $(".bcpo-label .mark_button").attr('title', 'Small - 4.5"(H) X 1.5"(W)  Large - 5.4"(H) X 2"(W)');
    }
    
    $('.bcpo-label .mark_button').addClass('simpletooltip');

    $('.bcpo-label .mark_button').attr('data-simpletooltip-position', 'right');

    $('.bcpo-label .mark_button').simpletooltip({
      position: 'right',
      border_color: '#25418F',
      color: '#FFFFFF',
      background_color: '#25418F',
      border_width: 1
    });        
  });
  
  var timer = setInterval(function() { 

    if ($(".bcpo-label label").length) {
      clearInterval(timer);
      $(".bcpo-images .bcpo-label label").append('<img src="//cdn.shopify.com/s/files/1/2401/4131/files/145-1450575_question-mark-faqs-icon-facebook-image-in-png.png" class="mark_qustion">');
       $(".bcpo-buttons .bcpo-label label").append('<img src="//cdn.shopify.com/s/files/1/2401/4131/files/145-1450575_question-mark-faqs-icon-facebook-image-in-png.png" class="mark_button">');
    }
    
  }, 100);
  
  var timer1 = setInterval(function(){
    
    if ($('.bcpo-label .mark_qustion').length) {
      clearInterval(timer1);

      var radioButtons = $(".bcpo-front-image-option");
      var index = radioButtons.index(radioButtons.filter(':checked'));

      if( index == 0 || index == 1 || index == 2 ) {

        $(".bcpo-label .mark_qustion").attr('title', 'These kits include an encoder for you to set your chosen 4-digit code in the cap. Kits of multiple bottles that allow you to set your own 4-digit codes.');

      } else {

        $(".bcpo-label .mark_qustion").attr('title', 'These bottles include a non-changeable 4-digit code set in the cap. Bottles with 4-digit codes that are provided for you and cannot be changed.');

      }


      $('.bcpo-label .mark_qustion').simpletooltip({
        position: 'right',
        border_color: '#25418F',
        color: '#FFFFFF',
        background_color: '#25418F',
        border_width: 3
      }); 

      $('.bcpo-label .mark_qustion').addClass('simpletooltip');

      $('.bcpo-label .mark_qustion').attr('data-simpletooltip-position', 'right');
    }
    
    if ($('.bcpo-label .mark_button').length) {
      clearInterval(timer1);

      var radioButtons = $(".bcpo-front-button-option");
      var index = radioButtons.index(radioButtons.filter(':checked'));

      if( index == 0 ) {
        $(".bcpo-label .mark_button").attr('title', 'Small - 4.5"(H) X 1.5"(W)');
      } 
      if( index == 1 ) {
        $(".bcpo-label .mark_button").attr('title', 'Large - 5.4"(H) X 2"(W)');
      }
      if( index == 2 ) {
        $(".bcpo-label .mark_button").attr('title', 'Small - 4.5"(H) X 1.5"(W)  Large - 5.4"(H) X 2"(W)');
      }


      $('.bcpo-label .mark_button').simpletooltip({
        position: 'right',
        border_color: '#25418F',
        color: '#FFFFFF',
        background_color: '#25418F',
        border_width: 3
      }); 

      $('.bcpo-label .mark_button').addClass('simpletooltip');

      $('.bcpo-label .mark_button').attr('data-simpletooltip-position', 'right');
    }
    
  }, 100);
  
  $('.reviews-slider').slick({
    dots: false,
   arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
  $('.opioid-slider').slick({
    dots: false,
   arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
 
  $("#contact-form").on("click", "input:checkbox", function(){
    if($(this).prop('checked')) {
    	$(this).val('checked');
    } else {
    	$(this).val('no');
    }
    
  });


});



